import { CoinsProvider } from './../../providers/coins/coins';
import { Observable } from 'rxjs/Observable';
import { SignalsProvider } from './../../providers/signals/signals';
import { Component, Input } from '@angular/core';

/**
 * Generated class for the SignalsStatsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'signals-stats',
  templateUrl: 'signals-stats.html'
})
export class SignalsStatsComponent {
  @Input('showBTC') showBTC: boolean;
  @Input('stocks') stocks: boolean = false;

  BTCPrice: number;
  oldBTCPrice: number = 8188.37;
  signalsMeta: Observable<any>;

  constructor(public signalsCtrl: SignalsProvider, public coinsCtrl: CoinsProvider) {

  }

  ngOnInit(){
    this.signalsMeta = this.signalsCtrl.getSignalsMeta(this.stocks);
    if(!this.stocks){
      this.coinsCtrl.getPriceSimple('BTC', 'USD').subscribe(price => {
        this.BTCPrice = price;
      })
    }

  }

  getBTCPerf(){
    if(this.BTCPrice){
      return (this.BTCPrice - this.oldBTCPrice) / this.oldBTCPrice * 100;
    }else{
      return 0;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/signals-stats/signals-stats.ts